import React, {CSSProperties, ReactNode, useContext, useLayoutEffect} from 'react'

import IconButton from '../buttons/IconButton.js'
import H4 from '../typography/H4.js'
import {ModalContext} from './ModalContext.js'
import {modalStyle} from './styles.js'

interface ModalHeaderProps {
    title?: ReactNode
    /** Shows the close button, which calls it */
    onClose?: () => void
    /** Between the title and the close button, at the right (extra icon buttons) */
    children?: ReactNode
    style?: CSSProperties
}

/**
 * The title row of a Modal: the title (H4) at the left, children and the close button at the right, with the header
 * gap below it. In a Modal the title names the dialog (aria-labelledby).
 */
export default function ModalHeader({title, onClose, children, style}: ModalHeaderProps) {
    const modal = useContext(ModalContext)
    const hasTitle = !!title

    useLayoutEffect(() => {
        if (modal && hasTitle) {
            return modal.registerTitle()
        }
    }, [modal?.registerTitle, hasTitle])

    return (
        <div style={{display: 'flex', marginBottom: modalStyle.headerGap, ...style}}>
            {hasTitle && <H4 id={modal?.titleId}>{title}</H4>}

            <div style={{flex: 1}} />

            {children}

            {onClose &&
                <IconButton aria-label='Sluiten' onClick={onClose}>
                    <i aria-hidden style={{color: modalStyle.closeIconColor}} className='mdi mdi-close' />
                </IconButton>
            }
        </div>
    )
}
